'use client';

import { useTranslations } from 'next-intl';
import { token } from '@terra/ui-styled-system';
import { ArrowDown01Icon } from '@terra/ui-icons';
import { Menu } from '../../components/menu';
import { BodyDefault, MetaDefault } from '../../components/typography';
import { ListPageOptionsMenuItem } from '../list-page/ListPageOptionsMenuItem';
import {
  useGroupByFieldMenuItems,
  type GroupByFieldSelection,
} from './useGroupByFieldMenuItems';

export type GroupByFieldRowProps<TField extends string> =
  GroupByFieldSelection<TField>;

export function GroupByFieldRow<TField extends string>(
  selection: GroupByFieldRowProps<TField>,
) {
  const t = useTranslations('designSystem.groupBy');
  const { fieldMenuItems, selectedFieldLabel } =
    useGroupByFieldMenuItems(selection);

  return (
    <Menu.MenuWithItems
      positioning={{ strategy: 'fixed', placement: 'bottom-end' }}
      selectionIndicator="checkmark"
      contentWidth="200px"
      items={fieldMenuItems}
      trigger={
        <ListPageOptionsMenuItem>
          <BodyDefault flex="1" textAlign="left">
            {t('buttonLabel')}
          </BodyDefault>
          <MetaDefault color="fg.neutral.subtle">
            {selectedFieldLabel}
          </MetaDefault>
          <ArrowDown01Icon
            size={14}
            color={token('colors.fg.neutral.subtle')}
          />
        </ListPageOptionsMenuItem>
      }
    />
  );
}
